<template>
  <div>
    <el-date-picker
      v-model="value"
      class="ag-table-float-el-daterange"
      size="mini"
      type="daterange"
      value-format="yyyy-MM-dd"
      :editable="false"
      format="MM/dd"
      unlink-panels
      @change="handleChange"
      :disabled-date="disabledDate"
      start-placeholder="区间"
      :end-placeholder="params.filterParams.opertype === 3 ? '搜索' : '过滤'"
    >
    </el-date-picker>
  </div>
</template>

<script>
export default {
  data () {
    return {
      value: []
    }
  },
  methods: {
    disabledDate (time) {
      if (
        this.params.filterParams.disabledDate &&
        typeof this.params.filterParams.disabledDate === 'function'
      ) {
        return this.params.filterParams.disabledDate(time)
      }
      return false
    },
    handleChange (val) {
      if (this.value) {
        this.params.parentFilterInstance(instance => {
          instance.onFloatingFilterChanged('contains', this.value.join(','))
        })
      } else {
        this.params.parentFilterInstance(instance => {
          instance.onFloatingFilterChanged('contains', null)
        })
      }
      if (this.params.filterParams.opertype === 3) {
        this.params.enter()
      }
    },
    onParentModelChanged (parentModel, event) {
      // When the filter is empty we will receive a null value here
      if (!parentModel) {
        this.value = []
      } else {
        this.value = parentModel.filter.split(',') || []
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .ag-table-float-el-daterange {
  position: absolute;
  left: 0;
  top: 0;
  width: calc(100% - 1px);
  height: 29px !important;
  border-radius: 0;
  border-color: transparent;
  padding-left: 7px !important;
  padding-right: 7px !important;
  &.is-active {
    border-color: #32b16c;
  }
  .el-input__prefix {
    display: none;
  }

  .el-input__icon.el-range__icon {
    display: none;
  }
}
</style>
